<script>
import {quillEditor} from 'vue-quill-editor'

export default {
  components: { quillEditor },
  created () {
    if (sessionStorage.getItem('shiftEventInfo') !== null) {
      this.content = JSON.parse(sessionStorage.getItem('shiftEventInfo')).eventInfo.eventNote
    } else {
      this.content = ''
    }
  },
  data () {
    return {
      maxLength: 1024,
      content: '',
      templength: 0,
      isEmoji: false,
      editorOption: {
        placeholder: '',
        modules: {
          toolbar: '#toolbar'
        }
      }
    }
  },
  methods: {
    // 失去焦点事件
    onEditorBlur () {},
    // 获得焦点事件
    onEditorFocus () {},
    // 内容改变事件
    onEditorChange (e, strValue, decimalNum) {
      // (strValue.replace(/<.*?>/g, '').substr(this.templength === 0 ? this.templength.length : this.templength - 1))
      if (this.isEmojiCharacter(strValue.replace(/<.*?>/g, ''))) {
        this.isEmoji = true
      } else {
        this.isEmoji = false
      }
      if (this.content.length > decimalNum) {
        e.quill.deleteText((e.quill.getLength() - 1) - (strValue.length - decimalNum), strValue.length - decimalNum, strValue)
      }
      this.$emit('transEvent', this.content, this.isEmoji)
      // this.templength = this.content.replace(/<.*?>/g, '').length
    },
    addDottedLine () {
      var currentContent = this.content + '<p style="text-align:center">-------------------------------------------------------------------------</p>'
      if (currentContent.length > this.maxLength) {
        this.content = this.content
        // this.templength = this.content.replace(/<.*?>/g, '').length
      } else {
        this.content = currentContent
        // this.templength = this.content.replace(/<.*?>/g, '').length
      }
    },
    addDottedMiddleLine () {
      var currentContent = this.content + '<p style="text-align:center">————————————</p>'
      if (currentContent.length > this.maxLength) {
        this.content = this.content
        // this.templength = this.content.replace(/<.*?>/g, '').length
      } else {
        this.content = currentContent
        // this.templength = this.content.replace(/<.*?>/g, '').length
      }
    },
    isEmojiCharacter (str) {
      var ranges = [
        // flag 🇦 >>> 🇿
        // '\ud83c[\udde6-\uddff]',
        // 麻将 纸牌  U+1F00x  >>> U+1F0Cx
        '\ud83c[\udc00-\udccf]',
        // 🅰️ >>> 🉑 U+1F17x >>> U+1F25x
        '\ud83c[\udd70-\ude5f]',
        // 🌀 >>> 🏿  U+1F30x >>> U+1F3Fx
        '\ud83c[\udf00-\udfff]',
        // 🐀 >>> 🙏  U+1F40x >>> U+1F64x
        '\ud83d[\udc00-\ude4f]',
        // 🚀 >>> 🛶  U+1F68x >>> U+1F6Fx
        '\ud83d[\ude80-\udeff]',
        // 🤐 >>> 🧀  U+1F91x >>> U+1F9Cx
        '\ud83e[\udd10-\uddcf]',
        // 微生物
        '\ud7c9[\ude00-\udeff]',
        // NUMBER SIGN + COMBINING ENCLOSING KEYCAP
        '\u0023\u20e3',
        // DIGIT + COMBINING ENCLOSING KEYCAP
        '[\u0030-\u0039]\u20e3',
        '\u00a9', '\u00ae',
        '\u2002', '\u2003', '\u2005',
        '\u203C',
        '\u2049',
        '\u2122',
        '\u2139',
        '[\u2194-\u2199]',
        '[\u21a9-\u21aa]',
        '[\u231a-\u231b]',
        '\u2328',
        '\u23cf',
        '[\u23e9-\u23fa]',
        '\u24c2',
        '[\u25aa-\u25ab]',
        '\u25B6',
        '\u25C0',
        '[\u25fb-\u25fe]',
        '[\u2600-\u27ff]',
        '[\u2934-\u2935]',
        '[\u2b05-\u2b1c]',
        '[\u2b50-\u2b55]',
        '[\u3030-\u303f]',
        '[\u3290-\u329f]'
      ]
      var reg = new RegExp(ranges.join('|'), 'g')
      if (str.match(reg)) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<template>
<div style="height:100%">
  <quillEditor
    v-model="content"
    ref="myQuillEditor"
    :options = "editorOption"
    @blur="onEditorBlur($event)"
    @focus="onEditorFocus($event)"
    @change="onEditorChange ($event, content, maxLength)"
  >
  <div id="toolbar" slot="toolbar" style="border-top-width: 0px; border-left-width: 0px; border-right-width: 0px; height:20%;">
          <span class="ql-formats" style="marign-left:40px"><button type="button" class="ql-underline" style="height:100%; width:100%"></button></span>
          <span class="ql-formats verticalLine"></span>
          <span class="ql-formats "><button type="button" class="ql-bold" style="height:100%; width:100%; "></button></span>
          <span class="ql-formats verticalLine" ></span>
          <span class="ql-formats"><button type="button" class="ql-align" value="" style="height:100%; width:100%"></button></span>
          <span class="ql-formats"><button type="button" class="ql-align" value="center" style="height:100%; width:100%"></button></span>
          <span class="ql-formats"><button type="button" class="ql-align" value="right" style="height:100%; width:100%"></button></span>
          <span class="ql-formats verticalLine" ></span>
          <span class="ql-formats url"><button type="button"  class="ql-list" value="bullet" style="height:100%; width:100%"></button></span>
          <span class="ql-formats verticalLine" ></span>
          <span class="ql-formats1 url7"><button type="button" @click="addDottedMiddleLine" style="height:100%; width:100%"></button></span>
          <!-- <span class="ql-formats"><button type="button" @click="addDottedLine" style="height:100%; width:100%;"></button></span> -->
          <span class="ql-formats1 url8" style="margin-left:1%"><button type="button" @click="addDottedLine" style="height:100%; width:100%" ></button></span>
  </div>
  </quillEditor>
</div>
</template>
<style>
.quill-editor{
  height: 100%;
}
.ql-snow{
  background: #ffffff;
  /* background: red; */
  border: none;
}
/* 宽度适应pop */
/* .ql-container{
  height: 80%;
  padding-right: 17.5%;
  padding-left:17.5%;
  font-size: 15px;
  color: black
} */
/* 字体适应pop */
.ql-container{
  max-height: 80%;
  font-size: 1.7vw;
  word-break:break-all
}
.ql-editor {
  font-size: 1.7vw;
  word-break:break-all
}
.ql-toolbar{
  height:20%;
}
.ql-formats{
  width:4.5%;
  height: 100%;
  background: #cecece;
  float:left
}
.ql-formats1{
  width:7%;
  height: 100%;
  float:left;
}
.url7{
  background:url(../assets/button/eventEditor/edit_button7.png)no-repeat center
}
.url8{
  background:url(../assets/button/eventEditor/edit_button8.png)no-repeat center
}
buttonSize{
  width: 100%;
  height: 100%;
}
.verticalLine{
border: #cecece solid 1px;
/* border: rgb(240, 102, 102) solid 1px; */
 width:1px
}
/* .ql-toolbar button{
  height: 50px
}
.ql-underline{
  height:100%;
  width:100%
} */
</style>



// WEBPACK FOOTER //
// src/components/quillEditor.vue